export const enum AnalyticsTarget {
    SHOW_NO_CONNECTION = '2508',
    SHOW_CONNECTION = '2509',
    CLICK_ATTACH = '2510',
    SHOW_CHAT_MAX_TEXT_LENGTH = '2511',
    SHOW_PENDING_MESSAGE = '2512',
    SHOW_FILE_NOT_UPLOADED = '2513',
    CLICK_FILES_SEND = '2514',
    CLICK_REPLY = '2516',
    CLICK_QUOTE_SEND = '2517',
    CLICK_HOVERING_BUTTON = '2518',
    CLICK_TO_FAVORITES = '2524',
    CLICK_FROM_FAVORITES = '2525',
    CLICK_BUTTON_SETTINGS_FAVORITES = '2526',
    CLICK_FAVORITES_GO_TO_HISTORY = '2527',
    CLICK_COPY = '2528',
    CLICK_CHAT_MENU = '2529',
    CLICK_TOGGLE_SETTING_NOTIFICATIONS = '2530',
    SHOW_CHAT_NOTIFICATIONS = '2531',
    CLICK_HISTORY_DATE = '2532',
    SHOW_DATEPICKER_OPEN = '2533',
    SHOW_DATEPICKER_CLOSE = '2534',
    CLICK_DATEPICKER_DATE = '2535',
    CLICK_OPEN_CHAT = '2536',
    SHOW_INITIAL_HISTORY = '2537',
    CLICK_BUTTON_UNAUTHORIZED_WIDGET = '2538',
    CLICK_ROLL_CHAT = '2540',
    CLICK_UNROLL_CHAT = '2541',
    SHOW_GAME_COIN = '9560',
    CLICK_GAME_COIN = '9561',
    CLICK_GAME_PLAY = '9562',
    CLICK_GAME_CANCEL = '9563',
    CLICK_GAME_REPLAY = '9564',
    CLICK_GAME_EXIT = '9565',
    CLICK_GAME_CLOSE = '9566',
    CLICK_GAME_PAUSE = '9567',
    CLICK_GAME_RESUME = '9568',
    CLICK_GAME_LEAVE = '9569',
    // SHOW_GAME_RESULTS = '9570',
    SHOW_GAME_RECORDS = '9571',
    CLICK_GAME_PLAY_AGAIN = '9572',
    CLICK_BUTTON_SETTINGS_SEARCH = '9573',
    CLICK_SEARCH_QUERY = '9574',
    SHOW_SEARCH_FIRST = '9575',
    CLICK_SEARCH_NAVBAR = '9576',
    // CLICK_SEARCH_CLOSE = '9577',
    CLICK_SEARCH_SCROLL_TO_BOTTOM = '9578',
    CLICK_BUTTON_SETTINGS_DOWNLOAD_HISTORY = '9579',
    CLICK_DOWNLOAD_HISTORY_AS_HTML = '9580',
    CLICK_DOWNLOAD_HISTORY_AS_TEXT = '9581',
    CLICK_QUICK_ACTIONS_MENU_OPEN = '9792',
    CLICK_QUICK_ACTIONS_MENU_CLOSE = '9793',
    CLICK_QUICK_ACTIONS_MENU_OUTWARD_CLOSE = '9794',
    CLICK_QUICK_ACTIONS_MENU_SELECT = '9816',
    CLICK_QUICK_ACTIONS_MENU_BACK = '9795',
    CLICK_HEADER_CHAT = '9800',
    CLICK_BUTTON_MEDIA_LINKS = '9801',
    CLICK_BUTTON_MEDIA_IMAGES = '9802',
    CLICK_BUTTON_MEDIA_FILES = '9803',
    // CLICK_BUTTON_MEDIA_VOICES = '',
    CLICK_BUTTON_SETTINGS_CHAT = '9804',
    CLICK_TOGGLE_SETTING_TIME_N_STATUS = '9810',
    CLICK_TOGGLE_SETTING_VIBRATION = '9811',
    CLICK_COLOR_SCHEME_N1 = '9805',
    CLICK_COLOR_SCHEME_N2 = '9806',
    CLICK_COLOR_SCHEME_N3 = '9807',
    CLICK_COLOR_SCHEME_N4 = '9808',
    CLICK_MEDIA_GO_TO_HISTORY = '9812',
    SHOW_BOT_REPLAY_LOADER = '9815',
    SHOW_AGENT_ACHIEVEMENTS = '9817',
    SHOW_CHAT_STATUS = '9791',
    CLICK_PREDICTIVE_INPUT_TIPS = '9828',
    SHOW_PREDICTIVE_INPUT_TIPS = '64789',
    CLICK_VOICE_START = '9829',
    CLICK_VOICE_CANCEL = '9830',
    CLICK_VOICE_SEND = '9831',
    CLICK_VOICE_LIMIT = '9832',
    CLICK_VOICE_TRANSCRIPT = '9833',
    CLICK_ADD_REACTION = '9834',
    CLICK_REMOVE_REACTION = '9835',
    SHOW_INFORMATION_BANNER = '64791',
    CONNECTION_TOOK_TO_LONG = '64788',
    SHOW_CSI_FORM = '64792',
    SHOW_CSI_FEEDBACK_FORM = '64793',
    CLICK_CSI_FORM_SUBMIT_NO_RATING = '64794',
    CLICK_CSI_FORM_SUBMIT = '64795',
    CLICK_CSI_FORM_CLOSE = '64796',
    SHOW_AWAIT_TIME_INDICATOR = '64797',
    SHOW_UNAUTH_START_SCREEN = '64798',
    CLICK_VK_MESSENGER = '64799',
    CLICK_WHATSAPP_MESSENGER = '64800',
    CLICK_TELEGRAM_MESSENGER = '64801',
    CLICK_VIBER_MESSENGER = '64802',
    SHOW_SURVEY_WIDGET = '76941',
    SURVEY_WIDGET_VALIDATION_ERROR = '76942',
    SURVEY_WIDGET_CLOSE = '76943',
    SURVEY_WIDGET_REPLY = '76944',
    SURVEY_WIDGET_CHOOSING_RESPONSE = '76945',
    CONNECTION_ERROR = '76946',
    AwaitTimeInSeconds = '11041', // Время ответа оператора в чате в секундах
    AwaitTimeInPercent = '11042', // Время ответа оператора в чате в процентах (фактическое/ожидаемое) * 100
    OperatorReactions = '84591',
}

export const enum KeyAstromTarget {
    BUTTONCLICK_HISTORY_LOAD_DElAY = 'Чат | Клики по кнопке | Показ виджета | От открытия до загрузки истории',
}
